import React, { useEffect, useRef, useState } from "react";
import PlacesAutocomplete from "react-places-autocomplete";
import { ControlLabel, FormControl } from "react-bootstrap";
import "./google_map_autocomplete.scss";
import { addressToString } from "../../../lib/postal_address";
import { If } from "react-extras";
const addressAttributes = {
  country: {
    format: "short_name",
    field: "Country",
  },
  locality: {
    format: "long_name",
    field: "Locality",
  },
  postal_code: {
    format: "long_name",
    field: "PostCode",
  },
  administrative_area_level_1: {
    format: "short_name",
    field: "AdministrativeArea",
  },
  street_number: {
    format: "long_name",
    field: "StreetNumber",
  },
  route: {
    format: "short_name",
    field: "Route",
  },
};

const placeToAddress = place => {
  const newAddress = place.address_components.reduce((agg, next) => {
    const attributeKeyName = next.types.find(type => addressAttributes[type]);
    if (!attributeKeyName) return agg;
    const desiredFormat = addressAttributes[attributeKeyName].format;
    agg[addressAttributes[attributeKeyName].field] = next[desiredFormat];
    return agg;
  }, {});

  if (newAddress.Route) {
    if (newAddress.StreetNumber) {
      newAddress.StreetAddress = [newAddress.StreetNumber + " " + newAddress.Route];
    } else {
      newAddress.StreetAddress = [newAddress.Route];
    }
    delete newAddress.StreetNumber;
    delete newAddress.Route;
  }
  return newAddress;
};

const GooglePlacesInput = ({ value, onChange }) => {
  const [address, updateAddress] = useState(addressToString(value));
  const attributionNodeRef = useRef(null);
  const placeService = useRef(null);
  useEffect(() => {
    if (attributionNodeRef.current) {
      placeService.current = new window.google.maps.places.PlacesService(
        attributionNodeRef.current
      );
    }
  }, []);

  const handleUpdateAddress = val => {
    if (!val) {
      onChange({});
    }
    updateAddress(val);
  };

  const handleSelect = async (selected, placeId) => {
    if (!placeService.current) return;
    const request = {
      placeId,
      fields: ["address_components"],
    };

    placeService.current.getDetails(request, (place, status) => {
      if (status === "OK") {
        const address = placeToAddress(place);
        updateAddress(addressToString(address));
        onChange(address);
      }
    });
  };

  const updateAddress2 = (val, e) => {
    e.preventDefault();
    onChange({
      ...value,
      StreetAddress: [value.StreetAddress?.[0], val],
    });
  };

  return (
    <div className={"google-map-autocomplete"}>
      <div ref={attributionNodeRef} />
      <PlacesAutocomplete value={address} onChange={handleUpdateAddress} onSelect={handleSelect}>
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => {
          return (
            <div>
              <FormControl
                {...getInputProps({
                  placeholder: "Search Places ...",
                  className: "location-search-input",
                })}
              />
              <If condition={!!suggestions.length}>
                <div className="autocomplete-dropdown-container">
                  {loading && <div>Loading...</div>}
                  {suggestions.map((suggestion, key) => {
                    const className = suggestion.active
                      ? "suggestion-item active"
                      : "suggestion-item";
                    return (
                      <div
                        key={key}
                        {...getSuggestionItemProps(suggestion, {
                          className,
                        })}>
                        <span>{suggestion.description}</span>
                      </div>
                    );
                  })}
                </div>
              </If>
            </div>
          );
        }}
      </PlacesAutocomplete>
      <If condition={value.StreetAddress?.[1] === undefined}>
        <button className="fake-link m-txs" onClick={e => updateAddress2("", e)}>
          + Address Line 2
        </button>
      </If>
      <If condition={value.StreetAddress?.[1] !== undefined}>
        <div className={"m-ts"}>
          <ControlLabel className="redcircle-form-label">Address Line 2 (optional)</ControlLabel>
          <FormControl
            placeholder={"eg Apt, Suite, etc"}
            onChange={e => updateAddress2(e.target.value, e)}
            value={value?.StreetAddress?.[1] || ""}
          />
        </div>
      </If>
    </div>
  );
};

export default GooglePlacesInput;
